
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/assets",
      function () {
        return require("private-next-pages/context-hub/assets.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/assets"])
      });
    }
  